goog.provide('el8.appshared.dialog.viewEducationalHandouts');

goog.require('el8.appservice.notifier');
goog.require('el8.data.educationalHandouts');
goog.require('el8.template.appshared.dialog.viewEducationalHandouts');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.string');
goog.require('el8.util.validate');

el8.appshared.dialog.viewEducationalHandouts = (function() {

    var searchForm = null;
    var uploadForm = null;
    var medlineTabIsInit = false;

    var that = new el8.uiwidget.NewDialog({
        title: 'Patient Education',
        modal: false,
        autoHeight: false,
        width: 600,
        height: 500,
        contentFn: function() {
            return el8.template.appshared.dialog.viewEducationalHandouts.content();
        },
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        setupTabbedNav();

        searchForm = new el8.uiwidget.Form({
            container: $('.search-handouts-form', that.getContentElt()),
            fields: [
                {
                    name: 'search',
                    type: 'input',
                    selector: ':input[name="search"]',
                    infoText: 'search by name or tag...'
                }
            ]
        });
        searchForm.render();

        bindTriggers();
    };

    function bindTriggers() {
        that.getContentElt().on('keydown', ':input[name="search"]',  function(e) {
            if (e.keyCode === KEYS.ENTER) {
                that.filter(searchForm.getVal('search'));
                return false;
            }

        }).on('click', '.search-trigger',  function(e) {
            e.preventDefault();
            that.filter(searchForm.getVal('search'));

        }).on('click', '.clear-search-trigger',  function(e) {
            e.preventDefault();
            searchForm.setVal('search', '');
            searchForm.initFocus();
            renderHandouts();

        }).on('click', '.select-trigger',  function(e) {
            e.preventDefault();
            var $item = $(this).closest('.handout-item');
            var itemId = $item.data('id');
            var handout = el8.data.educationalHandouts.getById(itemId);
            if (el8Globals['APP'] === 'chart') {
                el8.appchart.mgr.notes.addHandoutReference(handout);
                var dlg = el8Globals.FEATURES.IRSubmissions
                  ? el8.appchart.dialog.addEditImmunizationNew
                  : el8.appchart.dialog.addEditImmunization;
                if (dlg.isOpen()) {
                    dlg.getForm().getField('vis').setVal(handout.getName());
                }
            }
            var url = $(this).data('url');
            window.open(url);

        }).on('click', '.medline-select-trigger',  function(e) {
            if (el8Globals['APP'] !== 'chart') { return; }
            var $this = $(this);
            var url = $(this).data('url');

            el8.appchart.mgr.notes.addMedlineHandoutReference($this.text(), url);
            window.open(url);

        }).on('click', '.show-upload-handout-trigger',  function(e) {
            e.preventDefault();
            initUploadForm();

        }).on('click', '.remove-trigger',  function(e) {
            e.preventDefault();
            var $item = $(this).closest('.handout-item');
            var itemId = $item.data('id');
            el8.data.educationalHandouts.deleteItem(itemId, false, {
                successCb: function() {
                    $('.handout-item[data-id="'+itemId+'"]', that.getContentElt()).remove();
                }
            });
        });
    }

    function initUploadForm() {
        $('#upload-handout-section', that.getContentElt())
            .html($(el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutForm()));
        uploadForm = new el8.uiwidget.Form({
            container: $('#upload-handout-form', that.getContentElt()),
            fields: [
                {
                    name: 'handoutName',
                    type: 'input',
                    selector: ':input[name="handoutName"]',
                    infoText: 'name of handout...',
                    maxLength: 200,
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'tags',
                    type: 'input',
                    selector: ':input[name="tags"]',
                    infoText: 'tags for handout...'
                }
            ],
            validationOpts: el8.util.validate.standardOpts
        });
        uploadForm.setButtonElt($('#upload-handout-buttons', that.getContentElt()));
        uploadForm.addButton('upload', 'Upload File', function(_form) {
            var $fileElt = $(':input[type="file"]', _form.getContainer());
            if (!validateUploadForm(_form, $fileElt[0].files)) { return false; }

            var fd = new FormData();
            fd.append('handout_file', $fileElt[0].files[0]);
            fd.append('handout_name', _form.getVal('handoutName'));
            fd.append('tags', _form.getVal('tags'));

            uploadInProgress();

            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('handoutUpload'),
                data: fd,
                contentType: false,
                processData: false,
                success: function(data) {
                    el8.data.educationalHandouts.create(data);
                    renderHandouts();
                    $('#upload-handout-section', that.getContentElt()).empty();
                    initUploadForm();
                    el8.appservice.notifier.notify('Handout successfully uploaded.');
                },
                error: function() {
                    $('#upload-handout-inprogress', that.getContentElt()).remove();
                    $('#upload-handout-form-msg', that.getContentElt())
                        .html($(el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutError()));
                    $('#upload-handout-form-container', that.getContentElt()).show();
                    uploadForm.initFocus();
                    el8.uiwidget.alert('There was an error uploading the file. Please try again.');
                }
            });
        }, true);
        uploadForm.addButton('doReset', 'Reset', function(_form) {
            _form.reset();
            $(':input[type="file"]', _form.getContainer()).replaceWith(
                $(el8.template.appshared.dialog.viewEducationalHandouts.fileInput())
            );
            _form.initFocus();
        }, false);
        uploadForm.render();
    }

    function validateUploadForm(_form, fileList) {
        if (!fileList.length) {
            el8.uiwidget.alert('Please select a handout file to upload.');
            return false;
        }
        if (!_form.isValid()) {
            // Right now, requiring the name field is the only check in this form validator
            el8.uiwidget.alert('Please enter a name for the handout.');
            return false;
        }
        return true;
    }

    function uploadInProgress() {
        $('#upload-handout-form-container', that.getContentElt()).hide();
        $('#upload-handout-section', that.getContentElt())
            .append($(el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutInProgress()));
    }

    function renderHandouts(list) {
        list = list || el8.data.educationalHandouts.sorted();
        $('#educational-handouts-list', that.getContentElt()).html(
            el8.template.appshared.dialog.viewEducationalHandouts.list({
                handouts: list.map(function(a) { return a.asSoyMap(); }),
                selectable: true
            })
        );
    }

    function setupTabbedNav() {
        var tabbedNav = new el8.uiwidget.TabbedNav();
        tabbedNav.init({ wrapper: $('.tabbed-nav', that.getContentElt()) });

        if (el8Globals.APP === 'chart') {
            tabbedNav.addTab({
                title: "MedlinePlus",
                name: 'medline',
                contentDiv: $('.medline-section', that.getContentElt()),
                showTabFn: function() {
                    if (!medlineTabIsInit) {
                        populateMedlineTab();
                        medlineTabIsInit = true;
                    }
                }
            });
        }
        tabbedNav.addTab({
            title: 'Patient Handouts',
            name: 'elation',
            contentDiv: $('.elation-section', that.getContentElt())
        });
        tabbedNav.showTab('elation');
        if (el8Globals.APP !== 'chart') {
            tabbedNav.hideTabButton('elation');
        }
    }

    function populateMedlineTab() {
        if (el8Globals.APP !== 'chart') { return; }
        var $section = $('.medline-section', that.getContentElt());
        $section.addClass('el8Loading');
        $.el8_ajax({
            type: 'GET',
            url: el8Globals.PATIENT_PATH + 'medline-plus-data/',
            success: function(data) {
                var camelData = el8.util.keysFromUnderscoreToCamel(data);
                $section.html(
                    el8.template.appshared.dialog.viewEducationalHandouts.medlinePlusSection(camelData)
                ).removeClass('el8Loading');
            }
        });
    }


    var super_show = that.show;
    that.show = function() {
        super_show.call(that);
        that.refresh();
    };

    that.refresh = function() {
        that.getContentElt().addClass('dataLoading')
            .css('overflow', 'auto');
        el8.data.educationalHandouts.load(function() {
            renderHandouts();
            that.getContentElt().removeClass('dataLoading');
        }, false, true);

        populateMedlineTab();
    };

    that.filter = function(str) {
        that.getContentElt().addClass('dataLoading')
            .css('overflow', 'auto');
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('getEducationalHandouts'),
            data: {'q': str},
            success: function(data) {
                var list = el8.data.educationalHandouts.create(data);
                list.sort(function(a, b) {
                    return el8.util.string.cmp(a.getName().toLowerCase(), b.getName().toLowerCase());
                });
                renderHandouts(list);
                that.getContentElt().removeClass('dataLoading');
            }
        });
    };

    that.applySearch = function(searchTerm) {
        searchForm.setVal('search', searchTerm);
        that.filter(searchTerm);
    };

    return that;

})();
